/***
 * Created on 2024/12/5
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React, {useEffect} from 'react';
import illustration_landing_v2 from '../static/img/illustration/illustration-landing-illustration--v2.png';
import {useTranslation} from "react-i18next";
import {useNavigate} from "../hook/NavigateHook";
import {useQuery} from "@tanstack/react-query";

function JoinOrganizationSuccessComponent({setStandalone, setShowFooter}) {
    const { t } = useTranslation();
    const {goHome} = useNavigate();
    const pathname = window.location.pathname;

    const {data, isError} = useQuery({
        queryKey: ['get_join_organization_info'],
        queryFn: async () => {
            const data_id = pathname.split('/')?.[2];
            const response = await fetch(`/ajax/join-organization-info/${data_id}`);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            return data?.result;
        },
    })

    useEffect(()=>{
        if (setShowFooter || setStandalone) {
            setStandalone(true)
            setShowFooter(true)
        }

        return () => {
            if (setShowFooter || setStandalone) {
                setStandalone(false);
                setShowFooter(false)
            }
        }
    }, []);

    useEffect(() => {
        if (isError) {
            window.location.href = '/404_page_not_found';
        }
    }, [isError]);

    return (
          <div className="content-section successfully-joined">
            <div className="infographic">
              <div className="illus-wrap">
                <img src={illustration_landing_v2} alt=""/>
              </div>
            </div>
            <div className="info-content">
              <div className="info-content-head">
                  {t('@Organization Join Confirmation@')}
              </div>
              <div className="info-content-body">
                <div className="text-wrap">
                  <span className="fw5">
                      {t('@{{email}} has successfully joined {{organization_name}}.@', {email: data?.email, organization_name: data?.organization_name})}
                </span>.
                </div>
                <button className="q-btn q-btn-primary q-btn-round-corner !mt-24" onClick={goHome}>{t('@Return to Organization Center@')}</button>
              </div>
            </div>
          </div>
    )
}

export default JoinOrganizationSuccessComponent;